<template>
  <div class="activety-box">
    <div class="more-activety">
      <router-link to="/">
        <strong>更多活动</strong>
        <small>have fun!</small>
      </router-link>
    </div>
    <div class="activety-swiper slidetop" data-scroll data-scroll-call="animateMove">
       <swiper :options="swiperOption" v-if="activetyData.length > 0" ref="cultureSwiper">
        <swiper-slide class="activety-slide" v-for="item in activetyData.slice(0,6)" :key="item.id">
          <div class="activety-wrap" data-swiper-parallax="60%">
            <div class="activety-bg" data-scroll data-scroll-speed="-2" :style="{backgroundImage:`url(${item.cover})`}"></div>
            <strong>{{item.title}}</strong>
            <p>{{item.description}}</p>
            <a target="_block" :href="item.link">预约报名</a>
          </div>
        </swiper-slide>
       </swiper>
       <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data () {
    return {
      activetyData: [],
      swiperOption: {
        speed: 1000,
        loop: true,
        spaceBetween: 0,
        autoplay: {
          delay: 4000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        parallax: true,
        slidesPerView: 1,
        slidesPerGroup: 1
      }
    }
  },
  props: {
    scroll: Object
  },
  methods: {
    async getActivety () {
      const { data: res } = await this.$http.get('/events')
      this.activetyData = res.data
      setTimeout(() => {
        this.scroll.update()
        console.log(11);
      }, 400)
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  mounted () {
    this.getActivety()
  }
}
</script>

<style lang="less" scoped>
  @import url("@/assets/css/home/index.less");
</style>